module.exports = __webpack_public_path__ + "img/product-wrap-bg-selected-hen.f5808464.png";